export default __webpack_public_path__ + "static/media/sg-skai-swissotel-the-stamford.010224e2.jpg";